<h1 matDialogTitle class="text-xl font-medium text-gray-700">Confirm</h1>
<div mat-dialog-content>{{ confirmMessage }}</div>
<div mat-dialog-actions class="pt-24">
    <button mat-raised-button class="mat-accent mr-8" [class.mat-warn]="actionButtonColor === 'red'" (click)="dialogRef.close(true)">{{ actionButtonText }}</button>
    <button mat-button (click)="dialogRef.close(false)">Cancel</button>
</div>
